import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=626ba8b6&scoped=true&"
import script from "./OrderType.vue?vue&type=script&lang=js&"
export * from "./OrderType.vue?vue&type=script&lang=js&"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=626ba8b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ba8b6",
  null
  
)

export default component.exports